import { isFunction } from 'underscore';
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';

export const ValidatedControlAdapter = (WrappedComponent) => {
  const HOC = ({ serverErrorAdapterProps, validationProps, ...restProps }) => {
    const { onChange } = serverErrorAdapterProps;
    const { onValidate: onComponentValidate, ...restValidationProps } = validationProps;
    const onValidate = useCallback((...args) => {
      if (isFunction(onComponentValidate)) {
        onComponentValidate(...args);
      }
      onChange();
    }, [onComponentValidate, onChange]);

    const newValidationProps = useMemo(() => ({
      ...restValidationProps,
      onValidate,
    }), [onValidate, restValidationProps]);

    return <WrappedComponent {...restProps} validationProps={newValidationProps} />;
  };

  HOC.propTypes = {
    validationProps: PropTypes.shape({
      onValidate: PropTypes.func,
    }).isRequired,
    serverErrorAdapterProps: PropTypes.shape({
      onChange: PropTypes.func.isRequired,
    }).isRequired,
  };

  HOC.defaultProps = {
  };

  HOC.displayName = `ValidatedControlAdapter(${getDisplayName(WrappedComponent)})`;
  hoistNonReactStatics(HOC, WrappedComponent);

  return HOC;
};
